import React from "react";
import Context from "../../../Context";
import EssenceReferenceShipEdit from "../../Essence/EssenceReferenceShipEdit";
import Blocker from "../../Misc/Blocker";
import BsModal from "../../Misc/BsModal";
import SuperSelect from "../../Misc/SuperSelect";
import DtPicker from "../../Misc/DtPicker";

export default class CertificateEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      fileInputRef: React.createRef(),
      item: {},
      pending: false,
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  load = async () => {
    let item = { ...this.props.item };
    let files = [];

    if (item.id) {
      this.setState({ pending: true });
      files = await this.context.api.q("/object/file", {
        id: item.id,
      });
    }

    this.setState({ pending: false, item, files });
  };

  save = async () => {
    const { item } = this.state;
    const maxSize = window.appConfig.maxFileSize;

    this.setState({ pending: true });
    let saveData = {
      id: item.id || null,
      label: item.label,
      description: item.description,
      ship: item.ship,
      identity: item.identity,
      validtodate: item.validtodate || null,
      validfromdate: item.validfromdate || null,
      issueddate: item.issueddate || this.context.api.minDate,
      reminderdate: item.reminderdate || null,
    };
    let result = await this.context.api.q(`/certificate/set`, saveData);
    if (result !== false) {
      if (this.state.fileInputRef.current) {
        if (this.state.fileInputRef.current.files[0]) {
          let files = [];
          const file = this.state.fileInputRef.current.files[0];

          if (maxSize && file.size > maxSize) {
            this.context.toast(
              `Превышен максимальный размер загружаемого файла: ${Math.round(
                maxSize / 1024
              )} Кб`,
              "error"
            );
            this.setState({ pending: false });
            return;
          }

          let { encoded, type } = await this.context.api.toBase64(file);
          files.push({
            name: file.name,
            path: "", //file.path,
            size: file.size,
            date: file.lastModifiedDate,
            text: file.name,
            type: type,
            data: encoded,
          });

          let filesResult = await this.context.api.q("/object/file/set", {
            id: result.id,
            clear: true,
            files,
          });

          if (!filesResult) {
            this.context.toast("Не удалось загрузить файлы", "error");
          }
        }
      }

      this.props.onFinish();
    } else {
      this.context.toast("Не удалось сохранить документ", "error");
      this.setState({ pending: false });
    }
    this.setState({ pending: false });
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };
  dateTimeChange = (key, value) => {
    if (value instanceof Object) {
      this.setState((state) => {
        let item = state.item;
        item[key] = value.toDate();
        return { item };
      });
    }
  };

  render() {
    const { pending, item } = this.state;
    return (
      <>
        <BsModal show onClose={this.props.onClose}>
          <Blocker on={pending}>
            <h5 className="mb-5">
              {!item.id ? (
                <>Добавление документа</>
              ) : (
                <>Редактирование документа</>
              )}
            </h5>

            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Судно</label>
                  <SuperSelect
                    defaultValue={item.ship}
                    onChange={(value) => this.onChange("ship", value)}
                    essence="ship"
                    placeholder="Выберите судно..."
                    nameField="name"
                    idField="id"
                    refBtnClass="btn-white"
                    reference={{
                      title: "Суда",
                      essence: "ship",
                      showDescription: true,
                      showType: true,
                      itemEditor: (itemEditorProps) => (
                        <EssenceReferenceShipEdit {...itemEditorProps} />
                      ),
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Наименование</label>
                  <input
                    id="label"
                    value={item.label || ""}
                    onChange={(e) => this.onChange("label", e.target.value)}
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Серия, номер</label>
                  <input
                    id="identity"
                    value={item.identity || ""}
                    onChange={(e) => this.onChange("identity", e.target.value)}
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Описание</label>
                  <input
                    id="description"
                    value={item.description || ""}
                    onChange={(e) =>
                      this.onChange("description", e.target.value)
                    }
                    type="text"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>Файл</label>
                  <input
                    ref={this.state.fileInputRef}
                    type="file"
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Начало действия</label>
                  <DtPicker
                    isClearable
                    onChange={(v) => this.onChange("validfromdate", v)}
                    value={item.validfromdate}
                    time
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Конец действия</label>
                  <DtPicker
                    isClearable
                    onChange={(v) => this.onChange("validtodate", v)}
                    value={item.validtodate}
                    time
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Дата выпуска</label>
                  <DtPicker
                    isClearable
                    onChange={(v) => this.onChange("issueddate", v)}
                    value={item.issueddate}
                    time
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Дата напоминания</label>
                  <DtPicker
                    isClearable
                    onChange={(v) => this.onChange("reminderdate", v)}
                    value={item.reminderdate}
                    time
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between">
              <div></div>
              <div>
                <button onClick={this.save} className="btn btn-primary">
                  Сохранить
                </button>
              </div>
            </div>
          </Blocker>
        </BsModal>
      </>
    );
  }
}
